import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, TextField, Tooltip, IconButton } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

function CopyableTextField({ value, minRows = 3, onCopy }) {
    const { t } = useTranslation();
    const [copied, setCopied] = useState(false);

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(value ?? '');
            setCopied(true);
            setTimeout(() => setCopied(false), 1500);
            if (onCopy) onCopy();
        } catch (e) {
            // noop
        }
    };

    return (
        <Box>
            <TextField
                variant="outlined"
                fullWidth
                multiline
                minRows={minRows}
                value={value ?? ''}
                onClick={(e) => e.target.select()}
                onFocus={(e) => e.target.select()}
                InputProps={{ readOnly: true }}
                autoComplete="off"
                sx={{
                    '& .MuiInputBase-input': {
                        fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
                        whiteSpace: 'pre-wrap',
                        wordBreak: 'break-all',
                    },
                }}
            />
            <Box display="flex" justifyContent="flex-end" mt={1}>
                <Tooltip title={copied ? t('Copied!') : t('Copy')} placement="top" arrow>
                    <IconButton aria-label={t('Copy')} onClick={handleCopy}>
                        <ContentCopyIcon />
                    </IconButton>
                </Tooltip>
            </Box>
        </Box>
    );
}

export default CopyableTextField;


